import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Azienda } from '../../models/azienda';
import { Commessa } from '../../models/commessa';
import { Pagamento } from '../../models/pagamento';
import { Tipopagamento } from '../../models/tipopagamento';
import { Metodopagamento } from '../../models/metodopagamento';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { of, Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { EventEmitterService } from '../../service/event-emitter.service';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-pagamenti',
  templateUrl: './pagamenti.component.html',
  styleUrls: ['./pagamenti.component.css']
})
export class PagamentiComponent implements OnInit {
  busy: boolean= false;
  spinnervalue = 100;
  aziende: Azienda[];
  aziendefiltrate: Observable<Azienda[]>;
  azienda: Azienda;
  commesse: Commessa[];
  commessa: Commessa;
  targhe:Array<string>=[];
  telai:Array<string>=[];
  selectedValueAzienda: string=""; // FormControl;
  selectedValueTipopagamento: number;
  selectedValueMetodopagamento: number;
  selectedValueDocfiscale: string;
  selectedValueCommessa: number;
  selectedValueTarga: string="";
  selectedValueTelaio: string="";
  pagamento: Pagamento;
  pagamenti: Pagamento[]=[];
  cachepagamenti: Pagamento[]=[];
  tipipagamento: Tipopagamento[]=[];
  tipopagamento: Tipopagamento;
  metodipagamento: Metodopagamento[]=[];
  metodopagamento: Metodopagamento;
  importodovutototale:number=0;
  importopagatototale:number=0;
  ivadovutatotale:number=0;
  ivapagatatotale:number=0;
  saldototale:number=0;
  importodovutocommessa:number=0;
  importopagatocommessa:number=0;
  ivadovutacommessa:number=0;
  ivapagatacommessa:number=0;
  saldocommessa:number=0;
//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "Id",
    "Datapagamento",
    "Importo",
    "Azienda",
    "Commessa",
    "Tipopagamento",
    "Metodopagamento",
    "Note",
    "Docfiscale",
    "edit"];

  docfiscali = ['', 'Fattura', 'Nota Credito'];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);

  @ViewChild('paginator') paginator: MatPaginator;

  constructor(private httpClient: HttpClient, private sanitizer: DomSanitizer, private router: Router, private commonService: CommonService, private eventEmitterService: EventEmitterService) {
  //  this.selectedValueAzienda=new FormControl();

    this.pagamento=new Pagamento();
  }

  ngOnInit() {
    this.busy=true;
    this.commonService.getAllAziendeByTiporelazione(2).subscribe((res1) => {
      this.aziende = res1;

      this.aziendefiltrate = of(this.aziende);
      this.busy=false;
      this.commonService.getAllTipipagamento().subscribe((res2) => {
        this.tipipagamento = res2;

        this.commonService.getAllMetodipagamento().subscribe((res3) => {
            this.metodipagamento = res3;


/*
    this.commonService.getAllPagamentiByAziendaid().subscribe((res) => {
        this.pagamenti = res;

        if (this.commonService.selectedTipopagamento!=undefined) {
            this.selectedValueTipopagamento=this.commonService.selectedTipopagamento.Id;
        }
        if (this.commonService.selectedMetodopagamento!=undefined) {
            this.selectedValueMetodopagamento=this.commonService.selectedMetodopagamento.Id;
        }
*/
          });
      });

    });

    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Id",true);
    this.sortedDirection.set("Importo",true);
    this.sortedDirection.set("Datapagamento",true);
    this.sortedDirection.set("Azienda",true);
    this.sortedDirection.set("Commessa",true);
    this.sortedDirection.set("Tipopagamento",true);
    this.sortedDirection.set("Metodopagamento",true);
    this.sortedDirection.set("Note",true);
    this.sortedDirection.set("Doc. fiscale",true);


    this.eventEmitterService.subsVar4 = this.eventEmitterService.pagamentiAziendaSelected.subscribe((codiceazienda:number) => {
      this.commonService.getAllPagamentiByAziendaid(codiceazienda).subscribe((res) => {
        this.pagamenti=res;
        this.cachepagamenti=this.pagamenti;
        this.dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);
        this.dataSource.paginator = this.paginator;
      });
    });
  }

  isBusy(){
    return this.busy;
  }

  manageChangeTarga(){
    if (this.selectedValueTarga!=undefined){
      let tempCommesse: Commessa[]=[];
      this.commesse.forEach(element => {
        if (this.selectedValueTarga === element.Targaveicolo){
          tempCommesse.push(element);
        }
      });
      this.commesse=tempCommesse;
    }
    this.aggiornaLista();
  }

  manageChangeTelaio(){
    if (this.selectedValueTelaio!=undefined){
      let tempCommesse: Commessa[]=[];
      this.commesse.forEach(element => {
        if (this.selectedValueTelaio === element.Telaioveicolo){
          tempCommesse.push(element);
        }
      });
      this.commesse=tempCommesse;
    }
    this.aggiornaLista();
  }


  manageChangeCommessa(){
    this.selectedValueTipopagamento=undefined;
    this.selectedValueMetodopagamento=undefined;
    if (this.selectedValueCommessa!=undefined){
      this.commesse.forEach(element => {
        if (this.selectedValueCommessa === element.Codice){
          this.commessa=element;
          this.commonService.getAllPagamentiByCommessaid(this.commessa.Codice).subscribe((res) => {
            this.pagamenti=res;
            this.cachepagamenti=this.pagamenti;
            this.dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);
            this.dataSource.paginator = this.paginator;
          });
        }
      });
    }
    this.aggiornaimporticommessa();
  }

  manageChangeTipopagamento(){
    this.pagamenti=this.cachepagamenti;
    if (this.selectedValueTipopagamento!=undefined){
      this.tipipagamento.forEach(element => {
        if (this.selectedValueTipopagamento === element.Id){
          this.tipopagamento=element;
        }
      });
    }
    this.aggiornaLista();
  }

  manageChangeMetodopagamento(){
    this.pagamenti=this.cachepagamenti;
    if (this.selectedValueMetodopagamento!=undefined){
      this.metodipagamento.forEach(element => {
        if (this.selectedValueMetodopagamento === element.Id){
          this.metodopagamento=element;
        }
      });
    }
    this.aggiornaLista();
  }

  manageChangeDocfiscale(){
    this.pagamenti=this.cachepagamenti;
    if (this.selectedValueDocfiscale!=undefined){
      this.aggiornaLista();
    }
  }

  onFiltroAziendaKeyup(event:any){
    if (event.target.value!=undefined){
      this.aziendefiltrate = of(this.aziende.filter(a=> a.Nome.toLowerCase().indexOf(event.target.value.toLowerCase())>-1));
    }
  }

selectedAziendaOption(event) {
  this.selectedValueTipopagamento=undefined;
  this.selectedValueMetodopagamento=undefined;
  this.targhe=[];
  this.telai=[];
  this.selectedValueCommessa=0;
   const selectedValue = event.option.value;
   this.aziende.forEach(a => {
     if (a.Nome===selectedValue){
       this.azienda=a;

         this.commonService.getAllCommesseByAziendaid(a.Codice).subscribe((res1) => {
           this.commesse = res1;
           this.commonService.getAllOrfriclientiByAzienda(a.Codice).subscribe(res2 => {
             this.targhe=[];
             this.telai=[];
             res2.forEach(c => {
               if (c.Attributo==='Targa'){
                 this.targhe.push(c.Valore);
               }else if (c.Attributo==='Telaio'){
                 this.telai.push(c.Valore);
               }
             });

         });
        });
     }
   });
   this.eventEmitterService.onPagamentiAziendaSelected(this.azienda.Codice);
   this.aggiornaimporti();
  }

  aggiornaimporti() {
    this.importodovutototale=0;
    if (this.azienda!=undefined){
      this.commonService.getImportotaleByAziendaid(this.azienda.Codice).subscribe(res =>  {
        this.importodovutototale=res;
        this.ivadovutatotale=Number((res*configurazione.iva).toFixed(2));
        this.commonService.getAllPagamentiByAziendaid(this.azienda.Codice).subscribe((res1) => {
          let pagamentitotali:Pagamento[]=res1;
          let temp=0;
          pagamentitotali.forEach(p => {
            temp=temp+p.Importo;
          });
          this.importopagatototale=temp;
          this.ivapagatatotale=Number((temp*configurazione.iva).toFixed(2));
          this.saldototale=Number((this.importodovutototale+this.ivadovutatotale-this.importopagatototale).toFixed(2));

        });
      });
    }
   }

   aggiornaimporticommessa() {
     this.importodovutocommessa=0;
     this.ivadovutacommessa=0;
     this.importopagatocommessa=0;
     this.ivapagatacommessa=0;
     this.saldocommessa=0;
     if (this.commessa!=undefined){
       this.commonService.getImportotaleByCommmessaid(this.commessa.Codice).subscribe(res =>  {
         this.importodovutocommessa=res;
         this.ivadovutacommessa=Number((res*configurazione.iva).toFixed(2));
         this.commonService.getAllPagamentiByCommessaid(this.commessa.Codice).subscribe((res1) => {
           let pagamenticommessa:Pagamento[]=res1;
           let temp=0;
           pagamenticommessa.forEach(p => {
             temp=temp+p.Importo;
           });
           this.importopagatocommessa=temp;
           this.ivapagatacommessa=Number((temp*configurazione.iva).toFixed(2));
      //     this.saldocommessa=Number((this.importodovutocommessa+this.ivadovutacommessa-this.importopagatocommessa-this.ivapagatacommessa).toFixed(2));
      this.saldocommessa=Number((this.importodovutocommessa-this.importopagatocommessa).toFixed(2));

         });
       });
     }
    }
  cancel(){
    this.selectedValueTipopagamento=undefined;
    this.selectedValueMetodopagamento=undefined;
    this.selectedValueDocfiscale=undefined;
    this.selectedValueAzienda=undefined;
    this.selectedValueCommessa=0;
    this.selectedValueTarga="";
    this.selectedValueTelaio="";
    this.importodovutototale=0;
    this.importopagatototale=0;
    this.ivadovutatotale=0;
    this.ivapagatatotale=0;
    this.saldototale=0;
    this.importodovutocommessa=0;
    this.importopagatocommessa=0;
    this.ivadovutacommessa=0;
    this.ivapagatacommessa=0;
    this.saldocommessa=0;
    this.pagamenti=[];
    this.dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);
    this.dataSource.paginator = this.paginator;
  }



  aggiornaLista(){
    let templistapagamenti:Pagamento[]=this.pagamenti;
      if (this.selectedValueDocfiscale===undefined || this.selectedValueDocfiscale===''){
        templistapagamenti=templistapagamenti.filter(a => a.Docfiscale===null || a.Docfiscale===undefined);
      //  templistapagamenti=this.pagamenti;
      }else{
        templistapagamenti=templistapagamenti.filter(a => a.Docfiscale===this.selectedValueDocfiscale);
      }
      if (this.tipopagamento!=undefined){
        templistapagamenti=templistapagamenti.filter(a => a.Tipopagamento.Id===this.tipopagamento.Id);
        }
      if (this.metodopagamento!=undefined){
        templistapagamenti=templistapagamenti.filter(a => a.Metodopagamento.Id===this.metodopagamento.Id);
      }

      this.refreshLista(templistapagamenti);
    }

   refreshLista(listapagamenti:Pagamento[]){
     this.pagamenti=listapagamenti;
     this.dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);
     this.dataSource.paginator = this.paginator;
   }

  new(){
    this.commonService.selectedAzienda=this.azienda;
    this.commonService.selectedCommessa=this.commessa;
    this.commonService.selectedPagamento=undefined;
    this.router.navigate(['addpagamento']);
  }
  edit(pagamento: Pagamento): void {
      this.commonService.selectedPagamento=pagamento;
      this.router.navigate(['addpagamento']);
  }




  isHidden(){
      return 'none';

  }



  dateToNumber(d: Date): number {
    let s:string='99991231';
    if(d!=undefined && d!=null){

      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        let s2=String(d).replaceAll('-','')
//        console.log("not date:"+s2);
        return Number(s2);
      }

      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }
      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      s=year+month+day;
    }
    return Number(s);
  }


  manageClick(attributo: string){
    let tempList:Pagamento[];
    tempList=this.pagamenti;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Pagamento>(this.pagamenti);

   }

   export(){
     if (this.busy){
       console.log("Export già partito");
       return;
     }
     this.busy = true;
     let d:Date=new Date();
     let filename: string='reportpagamenti_'+d.toString()+'.xls';
     this.commonService
       .exportPagamenti(filename).subscribe(response => {
         this.busy = false;
         if (response===0){
           alert("Export termitato...controlla nei report il risultato");
           this.downloadExport(filename);
         }else{
           alert("Export andato in errore");
         }
     });
   }

   downloadExport(filename:string): any {
     const data = 'some text';
     const blob = new Blob([data], { type: 'application/octet-stream' });
    let fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
     this.commonService.downloadExportPagamenti(filename);

   }


}
